import * as React from 'react'
import {MapContainer, Marker, Popup, TileLayer, useMapEvents} from "react-leaflet";
import L from 'leaflet'
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";


function Neshan(props) {
    const leafletRef = React.useRef();
    const {t} = useTranslation();
    const selector = useSelector((st) => st)
    const [zoom, setZoom] = React.useState(null);
    const [isMoving, setIsMoving] = React.useState(false);
    const [lastRequestTime, setLastRequestTime] = React.useState(0);
    const [isTimerActive, setIsTimerActive] = React.useState(false);

    React.useEffect(() => {
        // leafletRef?.current?.openPopup();
    }, [])

    const MapEvents = () => {
        // let newDate = +new Date()

        useMapEvents({
            move() {
                setIsMoving(true)
                // setTimeStamp(newDate)
            },
            moveend(e) {
                setIsMoving(false)
                // setTimeStamp(newDate)
                //
                // if ((newDate - timeStamp) > 2000) {
                if (!props?.agent) {
                    const center = e?.target?.getCenter();
                    // const currentTime = Date.now();
                    // if (!isTimerActive || currentTime - lastRequestTime > 2000) {
                    //     setIsTimerActive(true);

                    // انجام درخواست
                    props.handleZoom(e?.target?._zoom)
                    props.setLngLat(center)
                    // props.mapObject.flyTo([center.lng, center.lng], props?.zoom)
                    // props.handlerSearchWithLocation(e?.latlng?.lng, e?.latlng?.lat)
                    props.handlerSearchWithLocation(center?.lng, center?.lat)

                    // ذخیره زمان آخرین درخواست
                    // setLastRequestTime(currentTime);

                    // تنظیم یک تایمر برای غیرفعال کردن تایمر پس از 2 ثانیه
                    // setTimeout(() => {
                    //     setIsTimerActive(false);
                    // }, 2000);
                    // }
                }
                // }

            },
        });
        return false;
    }

    const myIcon1 = L.icon({
        iconUrl: require('./../../assets/img/pointer-1.png'),
        iconSize: [50, 50], // size of the icon
        shadowSize: [50, 64],
        popupAnchor: [0, -20],
        // shadowSize: [4, 62],
        shadowAnchor: null
    });
    const myIcon2 = L.icon({
        iconUrl: require('./../../assets/img/pointer-2.png'),
        iconSize: [50, 50], // size of the icon
        shadowSize: [50, 64],
        popupAnchor: [0, -20],
        // shadowSize: [4, 62],
        shadowAnchor: null
    });
    const myIcon3 = L.icon({
        iconUrl: require('./../../assets/img/pointer-3.png'),
        iconSize: [50, 50], // size of the icon
        shadowSize: [50, 64],
        popupAnchor: [0, -20],
        // shadowSize: [4, 62],
        shadowAnchor: null
    });

    return (
        <div className="view-map">

            <MapContainer
                id="neshanMap"
                center={[props?.latToMap || props?.coordinates[0]?.pointX || 35.7, props?.lngToMap || props?.coordinates[0]?.pointY || 51.4]}
                zoom={props?.zoom}
                style={{height: "300px", width: "100%"}}
                ref={props?.setMapObject}
            >
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution=''
                />

                {props.agent ?
                    props?.coordinates?.map((item, index) =>
                        <Marker
                            position={[item?.pointX || props?.latToMap || 35.7, item?.pointY || props?.lngToMap || 51.4]}
                            icon={((item?.pointY == props?.lngToMap) && (item?.pointX == props?.latToMap)) ? myIcon1 : item?.agentId ? myIcon2 : myIcon3}>
                            {/*<img src={isMoving ? "/marker-2.png" : "/marker-1.png"} alt="marker" loading="lazy"/>*/}
                            <Popup ref={leafletRef}>
                                {item?.agentId ? '(' + selector?.single_review?.listReview[0]?.SLA?.ServiceName + ')' : t("singleOrder.serviceType.t31")}
                            </Popup>
                        </Marker>
                    )
                    :
                    <div className="map-marker">
                        <img src={isMoving ? "/marker-2.png" : "/marker-1.png"} alt="marker" loading="lazy"/>
                    </div>
                }

                <MapEvents/>

            </MapContainer>


            <div className="search-box">
                <input type="text" placeholder="جستجو..." onChange={(e) => props?.handleSearchAddress(e.target.value)}/>
            </div>
        </div>
    );
}


export default Neshan
